import React from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Logo from '../Components/Logo';
import Loading from '../Components/Loading';
import UnavailableSystem from '../Components/UnavailableSystem';

import styles from '../styles/DynamicModal.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

export default function ChangePassword() {
    const { openTimeModal } = useTimeModal();

    const [dbStatus, setDbStatus] = React.useState('checking');

    const [passwordInfo, setPasswordInfo] = React.useState({
        id: '',
        current_password: '',
        new_password: '',
        new_password_confirm: '',
    });

    const [loading, setLoading] = React.useState(true);
    const [currentPassword, setCurrentPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    React.useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await axios.get('/api/health');
            if (response.status === 200) {
                setDbStatus('connected');
            }
        } catch (err) {
            setDbStatus(`Отсутствует подключение к серверу ${err, err.message}`);
        } finally {
            setLoading(false);
        }
        }

        fetchData();
    }, [])

    const [status, setStatus] = React.useState('');

    const navigate = useNavigate();

    const closeModal = () => {
        navigate('/')
    }

    const handleChange = (field) => (e) => {
        const value = e.target.value;
    
        setPasswordInfo((prev) => ({ ...prev, [field]: value }));
    
        setErrorsForm((prevErrors) => {
            if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };
    
    const [errorsForm, setErrorsForm] = React.useState({});
    const validateForm = () => {
        const newErrors = {};

        if (!passwordInfo.current_password) {
            newErrors.current_password = 'Обязательное поле';
        }
        if (!passwordInfo.new_password) {
            newErrors.new_password = 'Обязательное поле';
        }
        if (!passwordInfo.new_password_confirm) {
            newErrors.new_password_confirm = 'Обязательное поле';
        }

        if (passwordInfo.new_password && (passwordInfo.new_password.length < 5 || passwordInfo.new_password.length > 150)) {
            newErrors.new_password = 'Значение не может быть меньше 5 и более 150 символов';
        }
        if (passwordInfo.new_password_confirm && (passwordInfo.new_password_confirm.length < 5 || passwordInfo.new_password_confirm.length > 150)) {
            newErrors.new_password_confirm = 'Значение не может быть меньше 5 и более 150 символов';
        }

        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const changePassword = () => {
        const token = localStorage.getItem('token');

        axios.put(`/api/change-password`, {
            currentPassword: passwordInfo.current_password,
            newPassword: passwordInfo.new_password,
            newPasswordConfirm: passwordInfo.new_password_confirm,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            setStatus('Пароль успешно изменен');
            navigate('/auth/logout');
            openTimeModal('Пароль успешно изменён. В целях безопасности заново войдите в учётную запись', 'success');
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Пароль не изменен. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        })
    };

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            changePassword();
        }
        setLoading(false);
    }

    return (
        <>
        {loading ? (
            <Loading />
        ) : dbStatus === 'connected' ? (
        <>
            <a style={{zIndex: '9999'}}><Logo to='/' position='fixed' /></a>
            <div style={{backgroundColor: '#00000000'}} className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onClick={(e) => e.stopPropagation()} onSubmit={(e) => changePassword(e)}>
                    <div className={styles.header}>
                        <div className={styles.headlineWithBackBtn}>
                            <h1>Изменить пароль</h1>
                        </div>
                        <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                    </div>
                    <div className={styles.main}>
                        <div className='labelInputWrapper'>
                            <a className='label'>Нынешний пароль</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                        type='text' 
                                        value={passwordInfo.current_password} 
                                        onChange={handleChange('current_password')} 
                                        className={errorsForm.current_password ? 'inputError' : ''}
                                        placeholder='' 
                                        minLength='' 
                                        maxLength='150' 
                                        required 
                                    />
                                    {errorsForm.current_password && <div className='errorUnderInput'>{errorsForm.current_password}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='labelInputWrapper'>
                            <a className='label'>Новый пароль</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                        type='text' 
                                        value={passwordInfo.new_password} 
                                        onChange={handleChange('new_password')} 
                                        className={errorsForm.new_password ? 'inputError' : ''}
                                        placeholder='' 
                                        minLength='' 
                                        maxLength='150' 
                                        required 
                                    />
                                    {errorsForm.new_password && <div className='errorUnderInput'>{errorsForm.new_password}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='labelInputWrapper'>
                            <a className='label'>Повторно новый пароль</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                        type='text' 
                                        value={passwordInfo.new_password_confirm} 
                                        onChange={handleChange('new_password_confirm')} 
                                        className={errorsForm.new_password_confirm ? 'inputError' : ''}
                                        placeholder='' 
                                        minLength='' 
                                        maxLength='150' 
                                        required 
                                    />
                                    {errorsForm.new_password_confirm && <div className='errorUnderInput'>{errorsForm.new_password_confirm}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        <div>{status}</div>
                        <button 
                        type='button' 
                        className='button' 
                        onClick={handleSave}
                        disabled={loading}
                        >
                            Изменить пароль
                        </button>
                    </div>
                </form>
            </div>
        </>
        ) : (
            <UnavailableSystem dbStatus={dbStatus} />
        )}
        </>
    )
};
